<script lang="ts">
    import Button from "@components/button/Button.svelte"

    export let label: string
    export let controls: string
    export let expanded = false
    export let action: (event: MouseEvent) => void = () => {}
    export let variant: "default" | "reader-tabs" = "default"

    function handleClick(event: MouseEvent) {
        event.stopPropagation()
        action(event)
    }
</script>

<div class="tab-menu-wrapper" class:reader-tabs={variant === "reader-tabs"}>
    <Button
        class="tab-menu-trigger"
        color="white"
        icon="kebab"
        aria-label={label}
        aria-haspopup="true"
        aria-controls={controls}
        aria-expanded={expanded}
        on:click={handleClick}
    />
    <slot />
</div>

<style>
    .tab-menu-wrapper {
        position: relative;
        display: grid;
        place-items: center;
        width: var(--tab-menu-button-size, 2.75rem);
        height: var(--tab-menu-button-size, 2.75rem);
        flex: 0 0 auto;
    }

    .tab-menu-wrapper.reader-tabs {
        --tab-menu-trigger-bg: var(--reader-tabs-tab-bg, var(--color-grey-0));
        --tab-menu-trigger-border: var(--reader-tabs-tab-border, var(--color-purple-100));
        --tab-menu-trigger-text: var(--reader-tabs-muted, var(--color-purple-700));
        --tab-menu-trigger-hover-bg: var(--reader-tabs-hover-bg, var(--color-purple-50));
        --tab-menu-trigger-hover-border: var(
            --reader-tabs-tab-hover-border,
            var(--color-purple-200)
        );
        --tab-menu-trigger-hover-text: var(--reader-tabs-strong, var(--color-purple-800));
        --tab-menu-trigger-active-bg: var(--reader-tabs-hover-bg, var(--color-purple-50));
        --tab-menu-trigger-active-border: var(
            --reader-tabs-tab-hover-border,
            var(--color-purple-200)
        );
        --tab-menu-trigger-active-text: var(--reader-tabs-strong, var(--color-purple-800));
    }

    .tab-menu-wrapper :global(.tab-menu-trigger) {
        width: 100%;
        min-width: 0;
        height: 100%;
        min-height: 100%;
        gap: 0;
        padding: 0;
    }

    .tab-menu-wrapper.reader-tabs :global(.tab-menu-trigger) {
        border-color: var(--tab-menu-trigger-border);
        background: var(--tab-menu-trigger-bg);
        color: var(--tab-menu-trigger-text);
    }

    .tab-menu-wrapper.reader-tabs :global(.tab-menu-trigger:hover) {
        border-color: var(--tab-menu-trigger-hover-border);
        background: var(--tab-menu-trigger-hover-bg);
        color: var(--tab-menu-trigger-hover-text);
    }

    .tab-menu-wrapper :global(.tab-menu-trigger[aria-expanded="true"]) {
        border-color: var(--color-purple-200);
        background: var(--color-purple-50);
    }

    .tab-menu-wrapper.reader-tabs :global(.tab-menu-trigger[aria-expanded="true"]) {
        border-color: var(--tab-menu-trigger-active-border);
        background: var(--tab-menu-trigger-active-bg);
        color: var(--tab-menu-trigger-active-text);
    }

    :global(.darkmode) .tab-menu-wrapper :global(.tab-menu-trigger[aria-expanded="true"]) {
        border-color: var(--color-grey-600);
        background: var(--color-grey-700);
        color: var(--color-grey-0);
    }

    :global(.darkmode) .tab-menu-wrapper.reader-tabs {
        --tab-menu-trigger-bg: var(--reader-tabs-tab-bg, var(--color-grey-800));
        --tab-menu-trigger-border: var(--reader-tabs-tab-border, var(--color-grey-700));
        --tab-menu-trigger-text: var(--reader-tabs-muted, var(--color-grey-300));
        --tab-menu-trigger-hover-bg: var(--reader-tabs-hover-bg, var(--color-grey-800));
        --tab-menu-trigger-hover-border: var(--reader-tabs-tab-hover-border, var(--color-grey-600));
        --tab-menu-trigger-hover-text: var(--reader-tabs-strong, var(--color-grey-50));
        --tab-menu-trigger-active-bg: var(--reader-tabs-hover-bg, var(--color-grey-800));
        --tab-menu-trigger-active-border: var(
            --reader-tabs-tab-hover-border,
            var(--color-grey-600)
        );
        --tab-menu-trigger-active-text: var(--reader-tabs-strong, var(--color-grey-50));
    }
</style>
